import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Container,
  Row,
  Col,
  Input,
  Spinner,
} from "reactstrap";
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Header from "components/Headers/Header";
import ReactModal from "react-modal";
import Swal from "sweetalert2";

const API_URL = "https://contratosback-dev.azurewebsites.net/api/v1";

const ReasignarJuridico = ({ id }) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [selectedUsuario, setSelectedUsuario] = useState("");

  const zIndexFix = () => {
    setTimeout(() => {
      const container = document.querySelector(".swal2-container");
      const popup = document.querySelector(".swal2-popup");
      if (container) container.style.zIndex = "9999";
      if (popup) popup.style.zIndex = "10000";
    }, 50);
  };

  const obtenerUsuariosPorArea = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API_URL}/AprobadoresJuridico`);
      setUsuarios(data);
    } catch (error) {
      console.error("Error al obtener los usuarios:", error);
    }
  }, []);

  useEffect(() => {
    obtenerUsuariosPorArea();
  }, [obtenerUsuariosPorArea]);

  const enviarDatos = async () => {
    if (!selectedUsuario) {
      Swal.fire({
        icon: "warning",
        title: "Debe seleccionar un usuario",
        willOpen: zIndexFix,
      });
      return;
    }

    setLoading(true);
    try {
      const { data } = await axios.put(
        `${API_URL}/ActualizaSolicitud/${id}/0`,
        { usuariosAsignacion: selectedUsuario },
        { headers: { "Content-Type": "application/json" } }
      );

      Swal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: data,
        willOpen: zIndexFix,
        confirmButtonText: "Aceptar",
      }).then(() => {
        setIsOpen(false);
      });
    } catch (error) {
      console.error("Error al enviar los datos:", error);
      Swal.fire({
        icon: "error",
        title: "Error al reasignar usuario",
        text: error.message,
        willOpen: zIndexFix,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="btn btn-secondary btn-lg"
        onClick={() => setIsOpen(true)}
        title="Añadir Aprobación Técnica"
        style={{
          padding: "5px 5px",
          fontSize: "10px",
          border: "2px solid blue",
        }}
      >
        Reasignar
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        contentLabel="Reasignar Usuario Jurídico"
        style={{ overlay: { zIndex: 2000 } }}
      >
        <button
          onClick={() => setIsOpen(false)}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#a4a5a5",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "70px",
            height: "70px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 3000,
          }}
        >
          cerrar
        </button>
        <Header />

        <Container className="mt--7" fluid>
          <Row>
            <Col>
              <Card className="shadow">
                <CardHeader className="border-0 text-center">
                  Reasignar Usuario Jurídico
                  <hr />
                </CardHeader>
                <CardBody>
                  {usuarios.length > 0 && (
                    <FormGroup>
                      <label htmlFor="usuarioSelect">
                        Seleccione un usuario
                      </label>
                      <Input
                        type="select"
                        id="usuarioSelect"
                        value={selectedUsuario}
                        onChange={(e) => setSelectedUsuario(e.target.value)}
                      >
                        <option value="">Seleccione</option>
                        {usuarios.map(({ id, nombre }) => (
                          <option key={id} value={id}>
                            {nombre}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  )}

                  <button
                    className="btn btn-primary btn-user btn-block"
                    onClick={enviarDatos}
                    disabled={isLoading}
                  >
                    {isLoading ? <Spinner size="sm" /> : "Confirmar"}
                  </button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default ReasignarJuridico;
